import {
    SET_TRIP_TYPE_VALUE,
    SET_COVER_FOR_VALUE,
    SET_DEPARTURE_COUNTRY_VALUE,
    SET_DESTINATION_COUNTRY_VALUE,
    SET_DEPARTURE_DATE_VALUE,
    SET_RETURN_DATE_VALUE,
    SET_NO_OF_TRAVELLERS_VALUE,
    SET_FULL_NAME_VALUE,
    EMAIL_SET_VALUE,
    PHONE_NUMBER_SET_VALUE,
    ID_NUMBER_SET_VALUE,
    SET_NO_OF_MINORS_VALUE,
    SET_AGE_VALUE,
    setFullNameValid,
    setTripTypeValid,
    setCoverForValid,
    setDepartureCountryValid,
    setDestinationCountryValid,
    setDepartureDateValid,
    setReturnDateValid,
    setNoOfTravellersValid,
    setAgeValid,
    setNoOfMinorsValid,
    setEmailValid,
    setPhoneNumberValid,
    setIdNumberValid,
    SET_FIRST_NAME_VALUE,
    setFirstNameValid,
    SET_MIDDLE_NAME_VALUE,
    SET_LAST_NAME_VALUE,
    setMiddleNameValid,
    setLastNameValid,
    SET_NO_18_69_VALUE,
    setNo18to69Valid,
    SET_NO_70_75_VALUE,
    setNo70to75Valid,
    SET_NO_76_80_VALUE,
    setNo76to80Valid,
    SET_NO_81_85_VALUE,
    setNo81to85Valid,
} from '../../../actions/travelUg/quote';
import { getDepartureDate, getSelectedCover, getTripType } from '../../../selectors/travelUg/quote';
import {
    validateSelection,
    validateNumber,
    validateDate,
    validateName,
    validateEmail,
    validateContactNumber,
} from '@om/validation';
import { validationIsEqual } from '../status';
import { validateUgandanId } from '@om/validation/src/validators/ugandan-id-validator';

let prevValidationAction = null;

export const quoteFormValidation = (store, next, action) => {
    const state = store.getState();

    const gatsbyStack = process.env.GATSBY_COUNTRY_SELECTOR;

    const departureDate = getDepartureDate(state);
    const selectedCover = getSelectedCover(state);

    let minAge = 0;
    let maxAge = 75;

    if (selectedCover.value === 'Student') {
        maxAge = 30;
    }

    if (selectedCover.value === 'Senior') {
        minAge = 76;
        maxAge = 85;
    }
    function extractMinMaxDays(range) {
        if (typeof range !== 'string') return null;

        if (range.includes('days')) {
            const match = range.match(/(\d+)-(\d+)/);
            if (!match) return null;

            let minDays = parseInt(match[1], 10);
            let maxDays = parseInt(match[2], 10);

            return {
                minDays: minDays !== 1 ? minDays - 1 : minDays,
                maxDays: maxDays - 1,
            };
        }

        const monthMatch = range.match(/(\d+)\s*month/);
        if (monthMatch) {
            const months = parseInt(monthMatch[1], 10);

            const startDate = new Date();
            const endDate = new Date();
            endDate.setMonth(startDate.getMonth() + months);

            const msInDay = 1000 * 60 * 60 * 24;
            const daysDiff = Math.ceil((endDate - startDate) / msInDay);

            const maxDays = Math.min(daysDiff, 364);

            return { minDays: 0, maxDays };
        }

        if (range.toLowerCase().includes('annual multi-trip')) {
            return { minDays: 0, maxDays: 364 };
        }

        return null;
    }

    function validateDestinationDate(departureDate, destinationDate) {
        const tripType = getTripType(state);

        const daysObj = extractMinMaxDays(tripType.value);

        if (daysObj !== null) {
            const { minDays, maxDays } = daysObj;

            // Parse the dates
            const [day1, month1, year1] = departureDate.split('/').map(Number);
            const [day2, month2, year2] = destinationDate.split('/').map(Number);

            const departure = new Date(year1, month1 - 1, day1);
            const destination = new Date(year2, month2 - 1, day2);

            // Check if departure date is greater than destination date
            if (departure > destination) {
                return 'Departure date cannot be later than the destination date.';
            }

            // Check if destination date is more than n days from departure date
            const maxDate = new Date(departure);
            maxDate.setDate(maxDate.getDate() + maxDays);

            const minDate = new Date(departure);
            minDate.setDate(minDate.getDate() + minDays);

            if (destination < minDate || destination > maxDate) {
                return `Return date must be ${minDays} to ${maxDays} days after the selected departure date.`;
            }
        }

        return null;
    }

    function validatePassport(passport) {
        const passportRegex = /^[A-Z0-9]{8,20}$/;
        return passportRegex.test(passport);
    }

    const validationAction = (() => {
        let error;
        let today = new Date();
        let validTodayDate = today.toLocaleDateString('en-NG').split('/').join('/');
        switch (action.type) {
            case SET_FULL_NAME_VALUE:
                error = validateName(action.value, {
                    min: 5,
                    max: 48,
                    subject: 'Full Name',
                });
                return setFullNameValid(error);

            case EMAIL_SET_VALUE:
                error = validateEmail(action.value, {
                    min: 6,
                    max: 200,
                    subject: 'Email address',
                    required: true,
                });
                return setEmailValid(error);

            case PHONE_NUMBER_SET_VALUE:
                error = validateContactNumber(action.value, {
                    subject: 'Phone Number',
                    countryCode: gatsbyStack,
                });
                return setPhoneNumberValid(error);

            case ID_NUMBER_SET_VALUE:
                error = validateUgandanId(action.value);

                if (error !== null) {
                    const passportIsValid = validatePassport(action.value);
                    error = passportIsValid ? null : 'Enter valid national id/passport number';
                }

                return setIdNumberValid(error);

            case SET_FIRST_NAME_VALUE:
                error = validateName(action.value, {
                    min: 2,
                    subject: 'First Name',
                });
                return setFirstNameValid(error);

            case SET_MIDDLE_NAME_VALUE:
                if (action.value !== '') {
                    error = validateName(action.value, {
                        min: 2,
                        subject: 'Middle Name',
                    });
                    return setMiddleNameValid(error);
                }

                return setMiddleNameValid(null);

            case SET_LAST_NAME_VALUE:
                error = validateName(action.value, {
                    min: 4,
                    subject: 'Last Name',
                });
                return setLastNameValid(error);

            case SET_TRIP_TYPE_VALUE:
                error = validateSelection(action.value, { min: 1, subject: 'Trip type value' });
                return setTripTypeValid(error);

            case SET_COVER_FOR_VALUE:
                error = validateSelection(action.value, { min: 1, subject: 'Cover for value' });
                return setCoverForValid(error);

            case SET_AGE_VALUE:
                error = validateNumber(action.value, { min: minAge, max: maxAge, subject: 'Age' });

                if (error === 'Oops, you need to enter an age greater than 76.') {
                    error = 'Oops, you need to enter an age greater than 75.';
                }

                if (error === 'Oops, you need to enter an age less than 85.') {
                    error = 'Oops, you need to enter an age less than 86.';
                }

                return setAgeValid(error);

            case SET_DEPARTURE_COUNTRY_VALUE:
                if (typeof action.value === 'string') {
                    error = validateName(action.value, { min: 1, subject: 'Departure country' });
                } else if (Array.isArray(action.value)) {
                    if (action.value.length === 0) {
                        error = 'Select at least one departure country';
                    } else {
                        error = null;
                    }
                } else {
                    error = 'Select a departure country';
                }

                return setDepartureCountryValid(error);

            case SET_DESTINATION_COUNTRY_VALUE:
                if (typeof action.value === 'string') {
                    error = validateName(action.value, { min: 1, subject: 'Destination country' });
                } else if (Array.isArray(action.value)) {
                    if (action.value.length === 0) {
                        error = 'Select at least one destination country';
                    } else {
                        error = null;
                    }
                } else {
                    error = 'Select a destination country';
                }

                return setDestinationCountryValid(error);

            case SET_DEPARTURE_DATE_VALUE:
                error = validateDate(action.value, { min: validTodayDate, subject: 'Departure date' });
                return setDepartureDateValid(error);

            case SET_RETURN_DATE_VALUE:
                error = validateDate(action.value, {
                    min: departureDate?.value,
                    subject: 'Return date',
                });

                if (error === null) {
                    error = validateDestinationDate(departureDate?.value, action.value);
                }
                return setReturnDateValid(error);

            case SET_NO_OF_TRAVELLERS_VALUE:
                error = validateNumber(action.value, { min: 0, subject: 'Number of adults' });
                return setNoOfTravellersValid(error);

            case SET_NO_OF_MINORS_VALUE:
                if (action.value !== '' || action.value !== null) {
                    error = validateNumber(action.value, { min: 0, subject: 'Number of minors' });
                    return setNoOfMinorsValid(error);
                }

                return setNoOfMinorsValid(null);

            case SET_NO_18_69_VALUE:
                if (action.value !== '' || action.value !== null) {
                    error = validateNumber(action.value, { min: 0, subject: 'Number of adults(18 to 69)' });
                    return setNo18to69Valid(error);
                }

                return setNo18to69Valid(null);

            case SET_NO_70_75_VALUE:
                if (action.value !== '' || action.value !== null) {
                    error = validateNumber(action.value, { min: 0, subject: 'Number of adults(70 to 75)' });
                    return setNo70to75Valid(error);
                }

                return setNo70to75Valid(null);

            case SET_NO_76_80_VALUE:
                if (action.value !== '' || action.value !== null) {
                    error = validateNumber(action.value, { min: 0, subject: 'Number of adults(76 to 80)' });
                    return setNo76to80Valid(error);
                }

                return setNo76to80Valid(null);

            case SET_NO_81_85_VALUE:
                if (action.value !== '' || action.value !== null) {
                    error = validateNumber(action.value, { min: 0, subject: 'Number of adults(81 to 85)' });
                    return setNo81to85Valid(error);
                }

                return setNo81to85Valid(null);

            default:
                return null;
        }
    })();

    if (!validationAction || validationIsEqual(validationAction, prevValidationAction)) {
        return next(action);
    }

    store.dispatch(validationAction);
    prevValidationAction = validationAction;
    return next(action);
};
